import React, { useReducer, useEffect } from 'react'
import useDebounce from '../../helpers/debounce'
import { algoliaPlacesInitialState } from './store/State'
import algoliaPlacesReducer from './store/Reducer'
import AlgoliaPlacesService from './Service'

const algoliaPlacesContext = {
  state: algoliaPlacesInitialState,
  handlers: {
    onSearchTermChanged: (_term: string) => {},
    onSetIsSelectorOpen: (_isOpen: boolean) => {}
  }
}

export type AlgoliaPlacesContext = typeof algoliaPlacesContext

export const AlgoliaPlacesContextProvider = React.createContext<AlgoliaPlacesContext>(algoliaPlacesContext)

const Provider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(algoliaPlacesReducer, algoliaPlacesInitialState)

  const searchTerm = useDebounce(state.searchTerm, 500)

  useEffect(() => {
    if (searchTerm.length >= 3) {
      AlgoliaPlacesService.loadOptions(dispatch, searchTerm)
    }
  }, [searchTerm])

  const handlers = {
    onSearchTermChanged: AlgoliaPlacesService.onSearchTermChanged(state, dispatch),
    onSetIsSelectorOpen: AlgoliaPlacesService.onSetIsSelectorOpen(state, dispatch)
  }

  const contextValue = {
    ...algoliaPlacesContext,
    state,
    handlers
  }

  return <AlgoliaPlacesContextProvider.Provider value={contextValue}>{children}</AlgoliaPlacesContextProvider.Provider>
}

export default Provider
